<script>
export default {
    name: 'SearchSuggestionsProducts',
    inject: ['$t'],
    props: {
        products: {
            type: Array,
            required: true
        }
    },
    computed: {
        suggestedProducts() {
            return this.products.slice(0, 3);
        }
    }
};
</script>

<template>
    <div v-if="products.length">
        <div class="text-md-v4 mb-4 font-bold">
            {{ $t('productsTitle') }}
        </div>
        <ul>
            <li
                v-for="(item, key) in suggestedProducts"
                :key="key"
                class="border-base-line mb-3 border-b last:mb-0 last:border-none last:pb-0"
            >
                <div class="h-22 mb-4 flex py-3 px-4 last:mb-0 lg:bg-white">
                    <a :href="item.link" class="h-16">
                        <div
                            class="product-image-container"
                            style="padding-bottom: 100%"
                        >
                            <img
                                class="product-image-photo"
                                :src="item.img"
                                loading="lazy"
                                width="64"
                                height="64"
                                :alt="`${item.title}, ${item.description}`"
                            />
                        </div>
                    </a>
                    <div class="flex w-full items-center justify-between pl-4">
                        <div>
                            <a
                                class="text-sl-v3 mb-1 block font-bold"
                                :title="item.title"
                                :href="item.link"
                            >
                                {{ item.title }}
                            </a>
                            <div class="text-xsl-v4 mb-1">
                                {{ item.description }}
                            </div>
                            <div class="text-mb font-bold">
                                <span v-html="item.price"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>
